import React, { Component } from "react";
import Select from "react-select";
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import { fetchDrivers, assignOrdersToDriver } from './redux';

const propTypes = {
  selectedOrders: PropTypes.array
}

const defaultProps = {
  selectedOrders: []
}

export class DriverListModal extends Component {
  constructor() {
    super();
    this.state = {
      drivers: [],
      selectedDriver: '',
    };
  }

  componentDidMount() {
    fetchDrivers(this.handleDriversFetchSuccess);
  }

  handleDriversFetchSuccess = (drivers = []) => this.setState({ drivers });

  handleOnSubmit = (e) => {
    const {
      selectedOrders,
      handleSuccess,
      assigningInboundDriver,
      assigningOutboundDriver,
    } = this.props;
    const {
      selectedDriver
    } = this.state;

    const payload = {
      DriverId: selectedDriver.value,
      SalesOrderIds: selectedOrders.map(selectedOrder => selectedOrder.SalesOrder_id),
    }
    const type = assigningInboundDriver ? 'inbound' : 'outbound';
    assignOrdersToDriver(payload, handleSuccess, type);
  };

  handleDriverSelect = (selectedDriver) => this.setState({ selectedDriver });

  render() {
    const {
      selectedDriver,
      drivers,
    } = this.state;

    return (
      <div>
        <Row style={{ marginBottom: "12px" }}>
          <Col sm={3}>
            <label style={{ float: 'right' }}>
              <Translate value="driver" />:
            </label>
          </Col>
          <Col sm={9}>
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  width: "300px",
                  backgroundColor: "white",
                  border: "1px solid #555555",
                  color: "black",
                  fontWeight: "400",
                }}
              >
                {selectedDriver.label || selectedDriver}
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors">
                {drivers.map((el) => {
                  return (
                    <MenuItem onClick={() => this.handleDriverSelect(el)} style={{
                      width: "300px",
                      backgroundColor: "white",
                      color: "black",
                      fontWeight: "400",
                    }}>
                      {el.label}
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>

        <Row className="centerStyle" style={{ marginTop: "50px" }}>
          <Button
            bsStyle="success"
            onClick={(e) => {
              this.handleOnSubmit(e);
            }}
            disabled={!this.state.selectedDriver}
          >
            <Translate value="assign" />
          </Button>
        </Row>
      </div>
    );
  }
}

DriverListModal.propTypes = propTypes
DriverListModal.defaultProps = defaultProps

export default DriverListModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/driverList/DriverListModal.jsx